import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CallingHangupIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingHangup",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.91 12.01c-.38-.17-.76-.33-1.17-.47-2.24-.81-4.82-1.27-7.51-1.27h-.24.01-.23c-2.69 0-5.27.47-7.66 1.32l.16-.05c-.95.34-1.75.72-2.51 1.16l.07-.04c-2.37 1.36-3.82 3.21-3.82 5.24v1.91c0 1.05.85 1.91 1.91 1.91h5.09c1.05 0 1.91-.85 1.91-1.91v-3.74c0-.7.57-1.26 1.27-1.27h7.64c.7 0 1.27.57 1.27 1.27v3.74c0 1.06.85 1.92 1.91 1.92h5.1c1.05 0 1.91-.85 1.91-1.91V17.9c0-2.37-1.99-4.49-5.09-5.89Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M30.72 22.58h-8.25c-.63 0-1.14-.51-1.14-1.14v-2.29c0-.63-.51-1.14-1.14-1.14h-8.64c-.63 0-1.14.51-1.14 1.14v2.29c0 .63-.51 1.14-1.14 1.14H1a1.14 1.14 0 1 1 0-2.28h7.11v-1.14c0-1.89 1.54-3.43 3.43-3.43h8.64c1.89 0 3.43 1.54 3.43 3.43v1.14h5.97v-2.43c0-3.15-2.56-5.71-5.71-5.71H7.86c-2.82 0-5.25 2.1-5.65 4.88a1.15 1.15 0 0 1-1.3.97 1.15 1.15 0 0 1-.97-1.3c.57-3.9 3.97-6.84 7.92-6.84h16c4.41 0 8 3.59 8 8v3.58c0 .63-.51 1.14-1.14 1.14Z"
      })
    })
  }));
};